import React from 'react';
import { Dropdown, Space, Typography } from 'antd';

import PageHeader from 'app/components/PageHeader';
import styled from '@emotion/styled';
import Button from 'app/components/Button';
import JobStatus, { JOB_STATUS, Status } from 'app/components/Status/JobStatus';
import get from 'lodash/get';
import { DownOutlined } from '@ant-design/icons';
import { JOB_DETAIL_MENU } from '../../constant';
import classes from './Header.module.scss';

const JobInfo = styled(Space)`
  div {
    > span:not(.ant-tag) {
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
      letter-spacing: 0.005em;
      text-align: right;
    }
  }
  div:first-of-type {
    > span {
      color: rgba(137, 145, 160, 1);
    }
  }
  &.info {
    div:last-child {
      > span {
        color: rgba(35, 43, 58, 1);
      }
    }
  }
`;
const Header = ({
  onBack,
  jobId,
  status,
  onBookInspection,
  className,
  onActionClick,
  overallReportResult,
  title = 'Job List'
}: {
  title?: string;
  status: string;
  jobId: string;
  className?: any;
  hiddenAssignOnsiteInspection?: boolean;
  onBack?: () => void;
  onBookInspection?: () => void;
  onActionClick?: (info: any) => void;
  overallReportResult?: string;
}) => {
  const shouldShow = React.useMemo(() => {
    const showByStatus = [
      JOB_STATUS.pendingAssign,
      JOB_STATUS.waitingAccept,
      JOB_STATUS.scheduled,
      JOB_STATUS.scheduledReject,
      JOB_STATUS.inProgress
    ];
    return showByStatus.includes(get(JOB_STATUS, status, ''));
  }, [status]);

  const showAssignOnsiteInspection = React.useMemo(() => {
    const showByStatus = [JOB_STATUS.pendingAssign, JOB_STATUS.scheduledReject];
    return showByStatus.includes(get(JOB_STATUS, status, ''));
  }, [status]);

  const shouldShowActionButton = React.useMemo(() => {
    const showByStatus = [JOB_STATUS.waitingAccept, JOB_STATUS.scheduled];
    return showByStatus.includes(get(JOB_STATUS, status, ''));
  }, [status]);

  return (
    <PageHeader className={className} onBack={onBack} title={title}>
      <Space size={[40, 36]}>
        <JobInfo className="info">
          <Typography.Text>Job ID</Typography.Text>
          <Typography.Text>{jobId}</Typography.Text>
        </JobInfo>
        <JobInfo>
          <Typography.Text>Overall Report Result</Typography.Text>
          <Status status={overallReportResult as any}></Status>
        </JobInfo>
        <JobInfo>
          <Typography.Text>Status</Typography.Text>
          <JobStatus status={status as any}>
            {get(JOB_STATUS, status, '')}
          </JobStatus>
        </JobInfo>

        {!shouldShow ? (
          <></>
        ) : (
          <>
            <Dropdown
              overlayClassName={classes.menu}
              overlayStyle={{ marginTop: 20 }}
              trigger={['hover']}
              menu={{
                items: JOB_DETAIL_MENU.filter((item) => {
                  if (item.isApplicable) {
                    return item.isApplicable({
                      assignOnsiteInspection: showAssignOnsiteInspection,
                      edit: shouldShowActionButton
                    });
                  }
                  return true;
                }).map((item) => {
                  return {
                    ...item,
                    onClick: (info) => {
                      if (info.key === 'assign-onsite-inspection') {
                        onBookInspection();
                        return;
                      }
                      onActionClick && onActionClick(info);
                    }
                  };
                })
              }}
            >
              <Button size="large" type="primary">
                Action
                <DownOutlined></DownOutlined>
              </Button>
            </Dropdown>
          </>
        )}
      </Space>
    </PageHeader>
  );
};

export default Header;
